import baseStore from '../generic_store';
import Axios from "axios";

const base = baseStore('projects');

const state = {
    ...base.state,
    base_url: '/api/projects',
    resourceName: 'Projet',
    model: {
        translatable: {
            name: {
                fr: '',
                en: ''
            },
            gdpr: {
                fr: '',
                en: ''
            }
        },
        name: {
            fr: '',
            en: ''
        },
        gdpr: {
            fr: '',
            en: ''
        },
        show_price: false,
        show_category: false,
        emerige_id: null,
        unlatch_id: null
    },
    isEmerigeSyncPending: false
};

const getters = {
    ...base.getters,
};

const actions = {
    ...base.actions,
    syncEmerige({state, commit, getters, dispatch}, {id: id}) {
        state.isEmerigeSyncPending = true;

        return Axios.post(`${getters.base_url}/${id}/emerige` )
            .then(response => {
                dispatch('toasts/add', {type: 'success', message: 'Sync done'}, {root: true})
            })
            .catch(error => {
                console.warn(error);
                if (error.response && error.response.status === 404) {
                    dispatch('toasts/add', {type: 'error', message: 'Resource item not found'}, {root: true})
                }
                if (error.status === 422) {
                    dispatch('toasts/add', {type: 'error', message: error.data.message}, {root: true})
                }
            })
            .finally(() => {
                state.isEmerigeSyncPending = false;
            });
    },
};

const mutations = {
    ...base.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

